var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('discovery-form',{attrs:{"action":"create","loading":_vm.loading,"updating":_vm.creating,"error-messages":_vm.errorMessages,"handle-submit":_vm.handleFormSubmit,"handle-discard":_vm.handleDiscard}})}
var staticRenderFns = []

export { render, staticRenderFns }